<template>
    <div>
        <div style="position: relative;">
            <RecommendationHeader subTitle="뒤로가기" title="훈련 설명서"></RecommendationHeader>
        </div>
        <div style="flex:1; overflow:auto; padding:0 20px; padding-top: 20px;">
            <div style="display:flex;">
                <div style="font-size:20px; font-weight:bold; flex:1;">{{title}}</div>
                <div style="color:#808080; font-size:16px; font-weight:500;">난이도 <span style="font-size:20px; color:#FF7111; font-weight:bold;">{{this.training_level}}</span></div>
            </div>
            <div style="margin-top:20px;">
                <img :src="$resourcePath + image_path" style="width:100%;"/>
            </div>

            <div class="label">준비물</div>
            <div style="color:#606060; font-size:16px; font-weight:bold; margin-top:10px;" v-html="checklist_title"></div>
            <div style="font-size:14px; font-weight:500; color:#606060; margin-top:10px;line-height: 20px;" v-for="each, i in checklist_explanation" :key="'a' + i" v-html="each.contents"></div>

            <div class="label">훈련설명</div>

            <div v-for="each, i in explanations" :key="i">
                <div style="color:#210F03; font-size:16px; font-weight:bold;margin-top:40px; " v-html="each.title"></div>
                <div style="height:10px;"></div>
                <div v-for="each2, j in each.contents_list" :key="i + '_' + j" style="color:#606060; font-size:16px; font-weight:500; margin-top:10px;line-height: 20px;" v-html="each2.contents"></div>
            </div>
            <div style="height:20px;"></div>
        </div>
        <div style="display:grid;place-items: center; margin-top:20px; margin-bottom: 20px;">
            <div style="background: #FF7111;padding: 20px; display:grid;place-items: center;border-radius: 50px; color:#210F03; font-size:14px; font-weight:bold;width:200px;" @click="showWriteForm">훈련 영상 업로드하기</div>
        </div>
        <LearnSoccerWriteForm :completeAction="beforeCompleteAction" :refer_idx="refer_idx" :isShowWriteForm="isShowWriteForm" :closeWriteForm="closeWriteForm" :formType="FORM_TYPE.TRAINING"></LearnSoccerWriteForm>
    </div>
</template>

<script>
    const FORM_TYPE = {
        TOPIC: 'TOPIC',
        SKILL: 'SKILL',
        TRAINING: 'TRAINING'
    }

    import RecommendationHeader from "../common/RecommendationHeader";
    import LearnSoccerWriteForm from '@/components/soccerhowmain/LearnSoccerWriteForm'
    import { MAIN_TYPE } from '@/Constants'
    export default {
        name: "TrainingExplanation",
        components: {RecommendationHeader, LearnSoccerWriteForm},
        props: {
            refer_idx: {
                type: [String, Number],
                default: -1
            }
        },
        data(){
            return {
                MAIN_TYPE: MAIN_TYPE,
                title : '',
                image_path : '',
                training_level : '',
                checklist_title : '',
                checklist_explanation : [],
                explanations : [],
                isShowWriteForm: false,
                FORM_TYPE: FORM_TYPE
            }
        },
        methods : {
            setIsShowWriteFrom() {
                this.isShowWriteForm = true
            },
            closeWriteForm() {
                this.isShowWriteForm = false
            },
            beforeCompleteAction(idx) {
                this.$GlobalStore.addModal('TrainingRequestDetail', { main_type: MAIN_TYPE.SOCCER_LEARN, isModalBackTransparent: true, isExpert: false, soccerhowIdx: idx })
            },
            async getTrainingExplanation(){
                const parameters = {};
                parameters.soccerhow_idx = this.refer_idx;
                const res = await this.$Axios.get('/api/home/training/explanation', { params: parameters });
                const explanation = res.data.training_explanation;

                this.title = explanation.title;
                this.image_path = explanation.image_path
                this.training_level = explanation.training_level;
                this.checklist_title = explanation.checklist_title;
                this.checklist_explanation = JSON.parse(explanation.checklist_explanation);
                this.explanations = JSON.parse(explanation.explanation);
            },
            showWriteForm(){
                this.$GlobalStore.addModal('UploadGuidePopup', {
                    isModalBackTransparent: true, transitionName: '', completeAction: () => {
                        // this.isShowWriteForm = true
                        this.$GlobalStore.addModal('WriteGroundPost', {
                            refer_training_banner_idx: this.refer_idx
                        })
                    }
                });
            }
        },
        created() {
            this.getTrainingExplanation();
        }
    }
</script>

<style scoped>
    .label{color:#210F03; font-size:20px; font-weight:bold; margin-top:30px;}
</style>